module.exports = __webpack_public_path__ + "static/media/REMAN White@3x.69f1cbea.png";